import template from './incomeCalculator.html';
import IncomeCalculatorCtrl from './incomeCalculatorCtrl';

export default {
  template,
  controller: IncomeCalculatorCtrl,
  controllerAs: 'vm',
};
